import { types, actions } from './requests'
export const GETWORKLISTSPAN_TYPES = {
    ...types('GETWORKLISTSPAN'),
}
export const GETWORKLISTSPAN_ACTIONS = {
    ...actions('GETWORKLISTSPAN'),
}
